//ts-
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import { createBrowserHistory } from 'history';
import * as serviceWorker from './serviceWorker';

import './index.scss';
import App from './App';
import store from './redux/store';
// Create browser history to use in the Redux store
const history = createBrowserHistory();

// Get the application-wide store instance, prepopulating with state from the server where available
const rootElement = document.getElementById('root');

ReactDOM.render(
	<Provider store={store as any}>
		<ConnectedRouter history={history}>
			<App />
		</ConnectedRouter>
	</Provider>,
	rootElement);

//ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

export interface AtlasLog {
	idleCounter: boolean;
}

// global store, use for debugging
declare global {
	interface Window {
		store: any;
		getFleetSummary: any;
		fleetSummaryDateTime: Date;
		atlasLog: AtlasLog;
	}
}

window.store = store;
window.fleetSummaryDateTime = new Date();
window.atlasLog = {
	idleCounter: false
};
